"use strict";
// tslint:disable
/**
 * Radio User Experience Engine API HM V2
 * Web-facing endpoints which are consumed and piped through to  Coordinator API.  Also handles initial determination of Domain and Application based on URI.
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
class Configuration {
    constructor(param = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}
exports.Configuration = Configuration;
//# sourceMappingURL=configuration.js.map